// extracted by mini-css-extract-plugin
export var numpadContainer = "_ky-1";
export var phoneButton = "_ky-0";